import { render, staticRenderFns } from "./CustomEvent.vue?vue&type=template&id=e4657666&scoped=true&"
import script from "./CustomEvent.vue?vue&type=script&lang=js&"
export * from "./CustomEvent.vue?vue&type=script&lang=js&"
import style0 from "./CustomEvent.vue?vue&type=style&index=0&id=e4657666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4657666",
  null
  
)

export default component.exports